<template>
<div class="sponsors-view">
    <div class="sponsor-added-notification" v-if="sponsorAdded">
        {{ $t("addSponsorView.sponsorAdded") }}
    </div>
    <div class="button-container">
        <button class="button button-green" @click="inviteSponsor()">
            {{ $t("sponsorsView.inviteSponsor") }}
        </button>
        <button class="button button-green" @click="addSponsor()">
            {{ $t("sponsorsView.addSponsor") }}
        </button>
    </div>

    <div v-if="participatingSponsors.length > 0">
        <h2>
            {{ $t("sponsorsView.participatingSponsors") }}
        </h2>

        <div v-for="s in participatingSponsors" :key="s.sponsorId">
            <kk-sponsor-list-item :sponsor="s" @reminder="sendReminder" @reinvite="reInvite" @bill="sendBill" />
        </div>
        <div v-for="s in paidSponsors" :key="s.sponsorId">
            <kk-sponsor-list-item :sponsor="s" @reminder="sendReminder" @reinvite="reInvite" />
        </div>
    </div>
    
    <h2>{{ $t("sponsorsView.sentInvitations") }}</h2>
    <div v-if="invitedSponsors.length == 0">
        <p>{{ $t("sponsorsView.noInvitations") }}</p>
    </div>
    <div v-for="s in invitedSponsors" :key="s.sponsorId">
        <kk-sponsor-list-item :sponsor="s" @reminder="sendReminder" @reInvite="reInvite" />
    </div>

    <div v-if="refusedSponsors.length > 0">
        <h2>{{ $t("sponsorsView.notParticipating") }}</h2>
        <div v-for="s in refusedSponsors" :key="s.sponsorId">
            <kk-sponsor-list-item :sponsor="s" @reminder="sendReminder" @reInvite="reInvite" />
        </div>
    </div>
    
</div>
</template>


<script lang="ts">
import { Sponsor, store } from "store";
import "@/components/SponsorListItem.vue";
import axios from "axios";
import {defineComponent} from "vue";

export default defineComponent({
    mounted() {
        for (let s of store.selectedEvent.sponsors) {
          s.sendingEmail = false;
        }

        this.sponsorAdded = this.$route.query.sponsorAdded !== undefined;

        store.page.title = this.$t("sponsorsView.title") as string;
        store.page.showTopNav = true;
    },
    data() {
        return {
            store: store,
            sponsorAdded: false,
            error: null
        };
    },
    computed: {
        participatingSponsors() {
            return store.selectedEvent.sponsors.filter(s =>
            s.participationStatus === "Participates");
        },
        paidSponsors() {
            return store.selectedEvent.sponsors.filter(s => s.participationStatus === "Paid");
        },
        invitedSponsors() {
            return store.selectedEvent.sponsors.filter(s => s.participationStatus === "NotAnswered" && s.invitedOn != null);
        },
        refusedSponsors() {
            return store.selectedEvent.sponsors.filter(s => s.participationStatus === "Refused");
        }
    },
    methods: {
        inviteSponsor() {
            this.$router.push("/invite-sponsor");
        },
        async reInvite(sponsor: Sponsor) {
            try {
                sponsor.sendingEmail = true;
                await axios.post(`sponsors/invite-email`, {
                    eventId: this.store.selectedEvent.eventId,
                    emails: [ sponsor.email ]
                });
                sponsor.invitedOn = new Date(Date.now());
            } catch (e) {
                // TODO: Handle error
            } finally {
                sponsor.sendingEmail = false;
            }
        },
        async sendBill(sponsor: Sponsor) {
            try {
                await axios.post(`sponsors/${sponsor.sponsorId}/sendbill`);
                sponsor.billSentOn = new Date(Date.now());
            } catch (err) {
                this.error = err;
            }
        },
        addSponsor() {
            this.$router.push("/add-sponsor");
        },
        async sendReminder(sponsor: Sponsor) {
            try {
                sponsor.sendingEmail = true;
                await axios.post(`sponsors/reminder-email`, sponsor);
                sponsor.notificationSentOn = new Date(Date.now())
            } catch(e) {
                // TODO: Handle error
            } finally {
                sponsor.sendingEmail = false;
            }
        }
    }
})

</script>